module.exports = __webpack_public_path__ + "static/img/btt4.4e7d24c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/btt4.png
// module id = xGS/
// module chunks = 1